<template>
  <div>
    <div class="countdown my-1" v-if="show">
      Bestellen Sie in den nächsten: <b>{{ hours }} Stunden {{ minutes }}  Minuten</b>
      <br>Dann versenden wir die Ware bei sofortiger Zahlung noch Heute.
    </div>
  </div>
</template>
<script>
export default
{
    name: "ks-timer",

                data: function data()
                {
                    return {
                        days: "",
                        hours: "",
                        minutes: "",
                        interval: "",
                        end: "",
                        show: ""
                    };
                },

                mounted: function()
                {
                    const _this = this;
                    const time = App.configKS.item.timeTo ? App.configKS.item.timeTo : 15;

                    this.end = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), time, 0, 0);
                    this.timerCount(this.end);
                    this.interval = setInterval(function()
                    {
                        _this.timerCount(_this.end);
                    }, 5000);
                },

                methods: {
                    timerCount: function timerCount(end)
                    {
                    // Get Today
                        const now = new Date();
                        const distance = end - now;

                        if (distance < 0)
                        {
                            this.show = false;
                        }
                        else
                        {
                            this.calcTime(distance);
                            this.show = true;
                        }

                    },
                    calcTime: function calcTime(dist)
                    {
                        this.days = Math.floor(dist / (1000 * 60 * 60 * 24));
                        this.hours = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                        this.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
                    }
                }
    }
</script>
